export default {"src":"/_next/static/media/coworking-icon-selected.a87c6e74.svg","height":96,"width":59,"blurWidth":0,"blurHeight":0};